import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ClipLoader } from 'react-spinners';
import { formatInTimeZone } from 'date-fns-tz';
import { AppInfoContext } from '../../../../../../App';
import ServiceType from './selectoptions/ServiceType';
import LocationComponent from '../../reportproblem/components/selectOptions/LocationComponent';
import ClosedWorkOrderUploadedFiles from './ClosedWorkOrderUploadedFiles';
import pdfIcon from './images/pdf.png';
import './ClosedWorkOrderDetails.css';
import './WorkOrderDetails.css';
import SewerageType from './selectoptions/SewerageType';
import SewerageActivity from './selectoptions/SeverageActivity';
import WsActivity from './selectoptions/wsActivity';

const fetchClosedWorkOrderDetails = async (id, token) => {
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const response = await fetch(`${apiUrl}/closed-work-orders/problem/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return response.json();
};

export default function ClosedWorkOrderDetails() {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);

  const token = localStorage.getItem('token');
  const problemId = appInformation.problemManagement.id;

  const [showUploadedFiles, setShowUploadedFiles] = useState(false);

  const [shouldFetch, setShouldFetch] = useState(false);

  useEffect(() => {
    if (problemId) {
      setShouldFetch(true);
    }
  }, [problemId]);

  const { data: closedWorkOrderData } = useQuery(
    ['closedWorkOrderDetails', problemId],
    () => fetchClosedWorkOrderDetails(problemId, token),
    {
      enabled: shouldFetch,
    },
  );

  const getLabelByValue = (value, enumType) => {
    const field = Object.values(enumType).find((type) => type.value === value);
    return field ? field.label : 'Unknown';
  };

  return (
    <div>
      {!closedWorkOrderData && (
        <div className="wo-details-spinner">
          <ClipLoader
            color={'gray'}
            loading={closedWorkOrderData}
            size={60}
            data-testid="loader"
          />
        </div>
      )}
      {closedWorkOrderData && !showUploadedFiles && (
        <div className="closed-wo-details-container">
          <div>
            <div>
              <label htmlFor="serialNumber" className="wo-details-label">
                Broj radnog naloga
              </label>
              <input
                disabled
                type="text"
                id="serialNumber"
                value={closedWorkOrderData.workOrder.serialNumber}
                name="serialNumber"
                className="wo-details-field"
              />
            </div>

            <div>
              <label htmlFor="serviceType" className="wo-details-label">
                Tip usluge
              </label>
              <input
                disabled
                type="text"
                id="serviceType"
                value={getLabelByValue(
                  closedWorkOrderData.serviceType,
                  ServiceType,
                )}
                name="serviceType"
                className="wo-details-field"
              />
            </div>

            {closedWorkOrderData.serviceType === 1 &&
              closedWorkOrderData.locationComponent !== 18 && (
                <>
                  <div>
                    <label htmlFor="sewerageType" className="wo-details-label">
                      Vrsta kanalizacije
                    </label>
                    <input
                      disabled
                      type="text"
                      id={'sewerageType'}
                      value={getLabelByValue(
                        closedWorkOrderData.sewerageType,
                        SewerageType,
                      )}
                      name={'sewerageType'}
                      className="wo-details-field"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="sewerageActivity"
                      className="wo-details-label"
                    >
                      Aktivnost održavanja
                    </label>
                    <input
                      disabled
                      type="text"
                      id={'sewerageActivity'}
                      value={getLabelByValue(
                        closedWorkOrderData.sewerageActivity,
                        SewerageActivity,
                      )}
                      name={'sewerageActivity'}
                      className="wo-details-field"
                    />
                  </div>
                </>
              )}

            <div>
              <label htmlFor="locationComponent" className="wo-details-label">
                Pozicija
              </label>
              <input
                disabled
                type="text"
                id="locationComponent"
                value={getLabelByValue(
                  closedWorkOrderData.locationComponent,
                  LocationComponent,
                )}
                name="locationComponent"
                className="wo-details-field"
              />
            </div>

            {closedWorkOrderData.serviceType === 0 && (
              <div>
                <label htmlFor="wsActivity" className="wo-details-label">
                  Aktivnost održavanja
                </label>
                <input
                  disabled
                  type="text"
                  id="wsActivity"
                  value={
                    closedWorkOrderData.wsActivity !== null
                      ? getLabelByValue(
                          closedWorkOrderData.wsActivity,
                          WsActivity,
                        )
                      : 'Bez unosa'
                  }
                  name="wsActivity"
                  className="wo-details-field"
                />
              </div>
            )}

            <label htmlFor="startDate" className="wo-details-label">
              Period početka radova
            </label>
            <div className="wo-details-date">
              <div>
                <input
                  type="text"
                  id="startDate"
                  name="startDate"
                  className="wo-details-date-field"
                  value={formatInTimeZone(
                    closedWorkOrderData.startDate,
                    'Europe/Paris',
                    'dd.MM.yyyy.',
                  )}
                  disabled
                />
              </div>
              <div>
                <input
                  type="text"
                  id="startTime"
                  name="startTime"
                  className="wo-details-date-field"
                  value={formatInTimeZone(
                    closedWorkOrderData.startDate,
                    'Europe/Paris',
                    'HH:mm',
                  )}
                  disabled
                />
              </div>
            </div>
            <label htmlFor="endDate" className="wo-details-label">
              Period završetka radova
            </label>
            <div className="wo-details-date">
              <div>
                <input
                  type="text"
                  id="endDate"
                  name="endDate"
                  className="wo-details-date-field  wo-details-last-field"
                  value={formatInTimeZone(
                    closedWorkOrderData.endDate,
                    'Europe/Paris',
                    'dd.MM.yyyy.',
                  )}
                  disabled
                />
              </div>
              <div>
                <input
                  type="text"
                  id="endTime"
                  name="endTime"
                  className="wo-details-date-field  wo-details-last-field"
                  value={formatInTimeZone(
                    closedWorkOrderData.endDate,
                    'Europe/Paris',
                    'HH:mm',
                  )}
                  disabled
                />
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="closedDate"
              className="wo-details-label closed-wo-second-column"
            >
              Datum i vrijeme zatvaranja
            </label>
            <div className="wo-details-date">
              <div>
                <input
                  type="text"
                  id="closedDate"
                  name="closedDate"
                  className="wo-details-date-field"
                  value={formatInTimeZone(
                    closedWorkOrderData.closedAt,
                    'Europe/Paris',
                    'dd.MM.yyyy.',
                  )}
                  disabled
                />
              </div>
              <div>
                <input
                  type="text"
                  id="closedTime"
                  name="closedTime"
                  className="wo-details-date-field"
                  value={formatInTimeZone(
                    closedWorkOrderData.closedAt,
                    'Europe/Paris',
                    'HH:mm',
                  )}
                  disabled
                />
              </div>
            </div>
            <div>
              <label htmlFor="note" className="wo-details-label">
                Napomena
              </label>
              <textarea
                disabled
                id="note"
                value={closedWorkOrderData.note}
                name="note"
                className="wo-details-field wo-details-textarea closed-wo-note"
              />
            </div>
            <div>
              <label htmlFor="report" className="wo-details-label">
                Izvještaj
              </label>
              <textarea
                disabled
                id="report"
                value={closedWorkOrderData.report}
                name="report"
                className="wo-details-field wo-details-textarea closed-wo-report"
              />
            </div>
            <div className="closed-work-order-buttons closed-work-order-buttons-mobile ">
              <button
                className="closed-work-order-files-button"
                onClick={() => setShowUploadedFiles(true)}
              >
                Datoteke
              </button>

              <div
                className="closed-work-order-report-icon-container"
                onClick={() =>
                  setAppInformation({
                    ...appInformation,
                    workOrderReport: {
                      modalActive: true,
                      problemId: closedWorkOrderData.workOrder.problem.id,
                    },
                  })
                }
              >
                <img
                  src={pdfIcon}
                  className="closed-work-order-report-icon"
                  alt="Icon"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {closedWorkOrderData && !showUploadedFiles && (
        <div className="closed-work-order-buttons closed-work-order-buttons-desktop">
          <button
            className="closed-work-order-files-button"
            onClick={() => setShowUploadedFiles(true)}
          >
            Datoteke
          </button>

          <div
            className="closed-work-order-report-icon-container"
            onClick={() =>
              setAppInformation({
                ...appInformation,
                workOrderReport: {
                  modalActive: true,
                  problemId: closedWorkOrderData.workOrder.problem.id,
                },
              })
            }
          >
            <img
              src={pdfIcon}
              className="closed-work-order-report-icon"
              alt="Icon"
            />
          </div>
        </div>
      )}
      <div>
        {showUploadedFiles && (
          <ClosedWorkOrderUploadedFiles
            problemId={closedWorkOrderData.workOrder.problem.id}
            workOrder={closedWorkOrderData.workOrder}
            hideModal={() => setShowUploadedFiles(false)}
          />
        )}
      </div>
    </div>
  );
}
